import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "../components/feature/Layout";
import Home from "../pages/home/page";
import Plot from "../pages/plot/page";
import Characters from "../pages/characters/page";
import Episodes from "../pages/episodes/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/plot", element: <Plot /> },
      { path: "/characters", element: <Characters /> },
      { path: "/episodes", element: <Episodes /> },
      { path: "/faq", element: <Faq /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;